// extracted by mini-css-extract-plugin
export var layoutContainer = "_49-0";
export var layoutContainerNoRounding = "_49-6";
export var layoutContainerOpen = "_49-5";
export var layoutContainerResizing = "_49-1";
export var mainContent = "_49-2";
export var resizeDivider = "_49-3";
export var slidePanel = "_49-4";